<template>
  <div class="modal-window">
    <w-table
      :data="tableData"
      highlight-current-row
      border
      stripe
      :span-method="rowspanMethod"
    >
      <w-table-column type="index" label="序号" width="65" align="center">
        <template slot-scope="scope">
          {{ scope.row.mainIndex }}
        </template>
      </w-table-column>
      <w-table-column label="操作时间" width="180" align="center">
        <template slot-scope="scope">
          {{ scope.row.CZSJ }}
        </template>
      </w-table-column>
      <w-table-column label="操作人" width="140" align="center">
        <template slot-scope="scope">
          {{ scope.row.CZRMC }}
        </template>
      </w-table-column>
      <w-table-column label="涉及扣分标准" width="240" align="left">
        <template slot-scope="scope">
          {{ scope.row.KFMC }}
        </template>
      </w-table-column>
      <w-table-column label="修改内容" align="left">
        <template slot-scope="scope">
          {{ scope.row.BGNR }}
        </template>
      </w-table-column>
    </w-table>
  </div>
</template>

<script>
export default {
  name: 'bccsDialog',
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    data: {
      handler(val) {
        this.getSpanArr(val)
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      tableData: [],
      spanArr: [],
      pos: null
    }
  },
  methods: {
    getSpanArr(data) {
      this.tableData = JSON.parse(JSON.stringify(data))
      this.spanArr = []
      this.pos = 0
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.tableData[i].mainIndex = 1
          this.tableData[i].subIndex = 1
          // 如果是第一条记录（即索引是0的时候），向数组中加入１
          this.spanArr.push(1)
          this.pos = 0
        } else {
          if (
            data[i].CZRGH === data[i - 1].CZRGH &&
            data[i].CZSJ === data[i - 1].CZSJ
          ) {
            this.tableData[i].mainIndex = this.tableData[i - 1].mainIndex
            this.tableData[i].subIndex = this.tableData[i - 1].subIndex + 1
            // 如果date相等就累加，并且push 0 （这里的判断视自己的判定依据改变）
            this.spanArr[this.pos] += 1
            this.spanArr.push(0)
          } else {
            this.tableData[i].mainIndex = this.tableData[i - 1].mainIndex + 1
            this.tableData[i].subIndex = 1
            // 不相等push 1
            this.spanArr.push(1)
            this.pos = i
          }
        }
      }
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    rowspanMethod({ row, rowIndex, column, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
        const cRow = this.spanArr[rowIndex]
        const cCol = cRow > 0 ? 1 : 0
        return {
          rowspan: cRow, // 合并的行数
          colspan: cCol // 合并的列数，为0表示不显示
        }
      }
    }
  }
}
</script>

<style></style>
